export default {
  howManyWorkers: "How many workers are you going to assign?",
  inventory: "Inventory",
  items: "Items",
  productionLine: "Production Line",
  selectItem: "Select the item you want to produce.",
  workers: "Workers"
};
